<template>
    <div class="estadisticas">
        <v-container grid-list-xl fluid class="pt-0">
            <v-layout row wrap>
                <v-flex sm12>
                    <v-card>
                        <v-toolbar color="primary" dark flat dense>
                            <v-toolbar-title>
                                Empleados por categorías
                            </v-toolbar-title>
                            <template slot="extension">
                                <v-tabs color="primary darken-1" dark slider-color="yellow" v-model="viewType">
                                    <v-tab :key="1" :href="`#tab-1`">
                                        Simple
                                    </v-tab>
                                    <v-tab :key="2" :href="`#tab-2`">
                                        Doble
                                    </v-tab>
                                    <v-tab :key="3" :href="`#tab-3`">
                                        Cuadrícula
                                    </v-tab>
                                </v-tabs>
                            </template>
                        </v-toolbar>

                        <v-card-text class="pa-0">
                            <v-tabs-items v-model="viewType">
                                <v-tab-item :key="1" :value="`tab-1`">
                                    <v-container fluid grid-list-xl class="pa-2">
                                        <v-layout align-center wrap>
                                            <v-flex sm12 pb-0>
                                                <v-alert
                                                    v-model="showErrorDataLoadedAlert"
                                                    type="error"
                                                    dismissible
                                                    transition="scale-transition"
                                                    dark
                                                >
                                                    No se han podido cargar todos los datos necesarios para este filtro.
                                                    Intente cargar el filtro nuevamente.
                                                </v-alert>
                                            </v-flex>

                                            <v-flex sm12>
                                                <v-card>
                                                    <v-card-title>
                                                        <v-flex sm5>
                                                            <empleado-stats-filter
                                                                tab-section-query="Tab1Section1"
                                                                :loading="loading"
                                                                @applyFilter="applyFilter"
                                                            ></empleado-stats-filter>
                                                        </v-flex>
                                                    </v-card-title>

                                                    <v-card-text class="pa-2  text-xs-center">
                                                        <template
                                                            v-if="
                                                                Tab1Section1.show &&
                                                                    $store.getters.STATS_TAB1_SEC1.data.length
                                                            "
                                                        >
                                                            <pie-chart
                                                                v-if="chartTypeTab1Sec1 === 1"
                                                                :title="`Empleados por ${Tab1Section1.text}`"
                                                                :cols="$store.getters.STATS_TAB1_SEC1.cols"
                                                                :data="$store.getters.STATS_TAB1_SEC1.data"
                                                                :key="Tab1Section1Id.pie"
                                                            ></pie-chart>

                                                            <bar-chart
                                                                v-if="chartTypeTab1Sec1 === 2"
                                                                :title="`Empleados por ${Tab1Section1.text}`"
                                                                :cols="$store.getters.STATS_TAB1_SEC1.cols"
                                                                :data="$store.getters.STATS_TAB1_SEC1.data"
                                                                :key="Tab1Section1Id.bar"
                                                            ></bar-chart>

                                                            <div class="text-xs-right">
                                                                <v-spacer></v-spacer>
                                                                <v-btn
                                                                    dark
                                                                    icon
                                                                    :color="
                                                                        chartTypeTab1Sec1 === 1 ? 'primary' : 'grey'
                                                                    "
                                                                    @click="chartTypeTab1Sec1 = 1"
                                                                >
                                                                    <v-icon small>fa fa-pie-chart</v-icon>
                                                                </v-btn>
                                                                <v-btn
                                                                    dark
                                                                    icon
                                                                    :color="
                                                                        chartTypeTab1Sec1 === 2 ? 'primary' : 'grey'
                                                                    "
                                                                    @click="chartTypeTab1Sec1 = 2"
                                                                >
                                                                    <v-icon small>fa fa-bar-chart</v-icon>
                                                                </v-btn>
                                                            </div>
                                                        </template>
                                                        <template v-else>
                                                            <div class="text-xs-center">
                                                                <h5>No existen datos que mostrar</h5>
                                                            </div>
                                                        </template>
                                                    </v-card-text>
                                                </v-card>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-tab-item>

                                <v-tab-item :key="2" :value="`tab-2`">
                                    <v-container fluid grid-list-xl class="pa-2">
                                        <v-layout align-center wrap>
                                            <v-flex sm12 pb-0>
                                                <v-alert
                                                    v-model="showErrorDataLoadedAlert"
                                                    type="error"
                                                    dismissible
                                                    transition="scale-transition"
                                                    dark
                                                >
                                                    No se han podido cargar todos los datos necesarios para este filtro.
                                                    Intente cargar el filtro nuevamente.
                                                </v-alert>
                                            </v-flex>

                                            <v-flex sm6>
                                                <v-card>
                                                    <v-card-title>
                                                        <v-flex sm12>
                                                            <empleado-stats-filter
                                                                tab-section-query="Tab2Section1"
                                                                :loading="loading"
                                                                @applyFilter="applyFilter"
                                                            ></empleado-stats-filter>
                                                        </v-flex>
                                                    </v-card-title>

                                                    <v-card-text class="pa-2  text-xs-center">
                                                        <template
                                                            v-if="
                                                                Tab2Section1.show && $store.getters.STATS_TAB2_SEC1.data
                                                            "
                                                        >
                                                            <pie-chart
                                                                v-if="chartTypeTab2Sec1 === 1"
                                                                :title="`Empleados por ${Tab2Section1.text}`"
                                                                :cols="$store.getters.STATS_TAB2_SEC1.cols"
                                                                :data="$store.getters.STATS_TAB2_SEC1.data"
                                                                :key="Tab2Section1Id.pie"
                                                            ></pie-chart>

                                                            <bar-chart
                                                                v-if="chartTypeTab2Sec1 === 2"
                                                                :title="`Empleados por ${Tab2Section1.text}`"
                                                                :cols="$store.getters.STATS_TAB2_SEC1.cols"
                                                                :data="$store.getters.STATS_TAB2_SEC1.data"
                                                                :key="Tab2Section1Id.bar"
                                                            ></bar-chart>

                                                            <div class="text-xs-right">
                                                                <v-spacer></v-spacer>
                                                                <v-btn
                                                                    dark
                                                                    icon
                                                                    :color="
                                                                        chartTypeTab2Sec1 === 1 ? 'primary' : 'grey'
                                                                    "
                                                                    @click="chartTypeTab2Sec1 = 1"
                                                                >
                                                                    <v-icon small>fa fa-pie-chart</v-icon>
                                                                </v-btn>
                                                                <v-btn
                                                                    dark
                                                                    icon
                                                                    :color="
                                                                        chartTypeTab2Sec1 === 2 ? 'primary' : 'grey'
                                                                    "
                                                                    @click="chartTypeTab2Sec1 = 2"
                                                                >
                                                                    <v-icon small>fa fa-bar-chart</v-icon>
                                                                </v-btn>
                                                            </div>
                                                        </template>
                                                        <template v-else>
                                                            <div class="text-xs-center">
                                                                <h5>No existen datos que mostrar</h5>
                                                            </div>
                                                        </template>
                                                    </v-card-text>
                                                </v-card>
                                            </v-flex>

                                            <v-flex sm6>
                                                <v-card>
                                                    <v-card-title>
                                                        <v-flex sm12>
                                                            <empleado-stats-filter
                                                                tab-section-query="Tab2Section2"
                                                                :loading="loading"
                                                                @applyFilter="applyFilter"
                                                            ></empleado-stats-filter>
                                                        </v-flex>
                                                    </v-card-title>

                                                    <v-card-text class="pa-2  text-xs-center">
                                                        <template
                                                            v-if="
                                                                Tab2Section2.show &&
                                                                    $store.getters.STATS_TAB2_SEC2.data.length
                                                            "
                                                        >
                                                            <pie-chart
                                                                v-if="chartTypeTab2Sec2 === 1"
                                                                :title="`Empleados por ${Tab2Section2.text}`"
                                                                :cols="$store.getters.STATS_TAB2_SEC2.cols"
                                                                :data="$store.getters.STATS_TAB2_SEC2.data"
                                                                :key="Tab2Section2Id.pie"
                                                            ></pie-chart>

                                                            <bar-chart
                                                                v-if="chartTypeTab2Sec2 === 2"
                                                                :title="`Empleados por ${Tab2Section2.text}`"
                                                                :cols="$store.getters.STATS_TAB2_SEC2.cols"
                                                                :data="$store.getters.STATS_TAB2_SEC2.data"
                                                                :key="Tab2Section2Id.bar"
                                                            ></bar-chart>

                                                            <div class="text-xs-right">
                                                                <v-spacer></v-spacer>
                                                                <v-btn
                                                                    dark
                                                                    icon
                                                                    :color="
                                                                        chartTypeTab2Sec2 === 1 ? 'primary' : 'grey'
                                                                    "
                                                                    @click="chartTypeTab2Sec2 = 1"
                                                                >
                                                                    <v-icon small>fa fa-pie-chart</v-icon>
                                                                </v-btn>
                                                                <v-btn
                                                                    dark
                                                                    icon
                                                                    :color="
                                                                        chartTypeTab2Sec2 === 2 ? 'primary' : 'grey'
                                                                    "
                                                                    @click="chartTypeTab2Sec2 = 2"
                                                                >
                                                                    <v-icon small>fa fa-bar-chart</v-icon>
                                                                </v-btn>
                                                            </div>
                                                        </template>
                                                        <template v-else>
                                                            <div class="text-xs-center">
                                                                <h5>No existen datos que mostrar</h5>
                                                            </div>
                                                        </template>
                                                    </v-card-text>
                                                </v-card>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-tab-item>

                                <v-tab-item :key="3" :value="`tab-3`">
                                    <v-container fluid grid-list-xl class="pa-2">
                                        <v-layout align-center wrap>
                                            <v-flex sm12 pb-0>
                                                <v-alert
                                                    v-model="showErrorDataLoadedAlert"
                                                    type="error"
                                                    dismissible
                                                    transition="scale-transition"
                                                    dark
                                                >
                                                    No se han podido cargar todos los datos necesarios para este filtro.
                                                    Intente cargar el filtro nuevamente.
                                                </v-alert>
                                            </v-flex>

                                            <v-flex sm6>
                                                <v-card>
                                                    <v-card-title>
                                                        <v-flex sm12>
                                                            <empleado-stats-filter
                                                                tab-section-query="Tab3Section1"
                                                                :loading="loading"
                                                                @applyFilter="applyFilter"
                                                            ></empleado-stats-filter>
                                                        </v-flex>
                                                    </v-card-title>

                                                    <v-card-text class="pa-2  text-xs-center">
                                                        <template
                                                            v-if="
                                                                Tab3Section1.show &&
                                                                    $store.getters.STATS_TAB3_SEC1.data.length
                                                            "
                                                        >
                                                            <pie-chart
                                                                v-if="chartTypeTab3Sec1 === 1"
                                                                :title="`Empleados por ${Tab3Section1.text}`"
                                                                :cols="$store.getters.STATS_TAB3_SEC1.cols"
                                                                :data="$store.getters.STATS_TAB3_SEC1.data"
                                                                :key="Tab3Section1Id.pie"
                                                            ></pie-chart>

                                                            <bar-chart
                                                                v-if="chartTypeTab3Sec1 === 2"
                                                                :title="`Empleados por ${Tab3Section1.text}`"
                                                                :cols="$store.getters.STATS_TAB3_SEC1.cols"
                                                                :data="$store.getters.STATS_TAB3_SEC1.data"
                                                                :key="Tab3Section1Id.bar"
                                                            ></bar-chart>

                                                            <div class="text-xs-right">
                                                                <v-spacer></v-spacer>
                                                                <v-btn
                                                                    dark
                                                                    icon
                                                                    :color="
                                                                        chartTypeTab3Sec1 === 1 ? 'primary' : 'grey'
                                                                    "
                                                                    @click="chartTypeTab3Sec1 = 1"
                                                                >
                                                                    <v-icon small>fa fa-pie-chart</v-icon>
                                                                </v-btn>
                                                                <v-btn
                                                                    dark
                                                                    icon
                                                                    :color="
                                                                        chartTypeTab3Sec1 === 2 ? 'primary' : 'grey'
                                                                    "
                                                                    @click="chartTypeTab3Sec1 = 2"
                                                                >
                                                                    <v-icon small>fa fa-bar-chart</v-icon>
                                                                </v-btn>
                                                            </div>
                                                        </template>
                                                        <template v-else>
                                                            <div class="text-xs-center">
                                                                <h5>No existen datos que mostrar</h5>
                                                            </div>
                                                        </template>
                                                    </v-card-text>
                                                </v-card>
                                            </v-flex>

                                            <v-flex sm6>
                                                <v-card>
                                                    <v-card-title>
                                                        <v-flex sm12>
                                                            <empleado-stats-filter
                                                                tab-section-query="Tab3Section2"
                                                                :loading="loading"
                                                                @applyFilter="applyFilter"
                                                            ></empleado-stats-filter>
                                                        </v-flex>
                                                    </v-card-title>

                                                    <v-card-text class="pa-2  text-xs-center">
                                                        <template
                                                            v-if="
                                                                Tab3Section2.show &&
                                                                    $store.getters.STATS_TAB3_SEC2.data.length
                                                            "
                                                        >
                                                            <pie-chart
                                                                v-if="chartTypeTab3Sec2 === 1"
                                                                :title="`Empleados por ${Tab3Section2.text}`"
                                                                :cols="$store.getters.STATS_TAB3_SEC2.cols"
                                                                :data="$store.getters.STATS_TAB3_SEC2.data"
                                                                :key="Tab3Section2Id.pie"
                                                            ></pie-chart>

                                                            <bar-chart
                                                                v-if="chartTypeTab3Sec2 === 2"
                                                                :title="`Empleados por ${Tab3Section2.text}`"
                                                                :cols="$store.getters.STATS_TAB3_SEC2.cols"
                                                                :data="$store.getters.STATS_TAB3_SEC2.data"
                                                                :key="Tab3Section2Id.bar"
                                                            ></bar-chart>

                                                            <div class="text-xs-right">
                                                                <v-spacer></v-spacer>
                                                                <v-btn
                                                                    dark
                                                                    icon
                                                                    :color="
                                                                        chartTypeTab3Sec2 === 1 ? 'primary' : 'grey'
                                                                    "
                                                                    @click="chartTypeTab3Sec2 = 1"
                                                                >
                                                                    <v-icon small>fa fa-pie-chart</v-icon>
                                                                </v-btn>
                                                                <v-btn
                                                                    dark
                                                                    icon
                                                                    :color="
                                                                        chartTypeTab3Sec2 === 2 ? 'primary' : 'grey'
                                                                    "
                                                                    @click="chartTypeTab3Sec2 = 2"
                                                                >
                                                                    <v-icon small>fa fa-bar-chart</v-icon>
                                                                </v-btn>
                                                            </div>
                                                        </template>
                                                        <template v-else>
                                                            <div class="text-xs-center">
                                                                <h5>No existen datos que mostrar</h5>
                                                            </div>
                                                        </template>
                                                    </v-card-text>
                                                </v-card>
                                            </v-flex>

                                            <v-flex sm6>
                                                <v-card>
                                                    <v-card-title>
                                                        <v-flex sm12>
                                                            <empleado-stats-filter
                                                                tab-section-query="Tab3Section3"
                                                                :loading="loading"
                                                                @applyFilter="applyFilter"
                                                            ></empleado-stats-filter>
                                                        </v-flex>
                                                    </v-card-title>

                                                    <v-card-text class="pa-2  text-xs-center">
                                                        <template
                                                            v-if="
                                                                Tab3Section3.show &&
                                                                    $store.getters.STATS_TAB3_SEC3.data.length
                                                            "
                                                        >
                                                            <pie-chart
                                                                v-if="chartTypeTab3Sec3 === 1"
                                                                :title="`Empleados por ${Tab3Section3.text}`"
                                                                :cols="$store.getters.STATS_TAB3_SEC3.cols"
                                                                :data="$store.getters.STATS_TAB3_SEC3.data"
                                                                :key="Tab3Section3Id.pie"
                                                            ></pie-chart>

                                                            <bar-chart
                                                                v-if="chartTypeTab3Sec3 === 2"
                                                                :title="`Empleados por ${Tab3Section3.text}`"
                                                                :cols="$store.getters.STATS_TAB3_SEC3.cols"
                                                                :data="$store.getters.STATS_TAB3_SEC3.data"
                                                                :key="Tab3Section3Id.bar"
                                                            ></bar-chart>

                                                            <div class="text-xs-right">
                                                                <v-spacer></v-spacer>
                                                                <v-btn
                                                                    dark
                                                                    icon
                                                                    :color="
                                                                        chartTypeTab3Sec3 === 1 ? 'primary' : 'grey'
                                                                    "
                                                                    @click="chartTypeTab3Sec3 = 1"
                                                                >
                                                                    <v-icon small>fa fa-pie-chart</v-icon>
                                                                </v-btn>
                                                                <v-btn
                                                                    dark
                                                                    icon
                                                                    :color="
                                                                        chartTypeTab3Sec3 === 2 ? 'primary' : 'grey'
                                                                    "
                                                                    @click="chartTypeTab3Sec3 = 2"
                                                                >
                                                                    <v-icon small>fa fa-bar-chart</v-icon>
                                                                </v-btn>
                                                            </div>
                                                        </template>
                                                        <template v-else>
                                                            <div class="text-xs-center">
                                                                <h5>No existen datos que mostrar</h5>
                                                            </div>
                                                        </template>
                                                    </v-card-text>
                                                </v-card>
                                            </v-flex>

                                            <v-flex sm6>
                                                <v-card>
                                                    <v-card-title>
                                                        <v-flex sm12>
                                                            <empleado-stats-filter
                                                                tab-section-query="Tab3Section4"
                                                                :loading="loading"
                                                                @applyFilter="applyFilter"
                                                            ></empleado-stats-filter>
                                                        </v-flex>
                                                    </v-card-title>

                                                    <v-card-text class="pa-2  text-xs-center">
                                                        <template
                                                            v-if="
                                                                Tab3Section4.show &&
                                                                    $store.getters.STATS_TAB3_SEC4.data.length
                                                            "
                                                        >
                                                            <pie-chart
                                                                v-if="chartTypeTab3Sec4 === 1"
                                                                :title="`Empleados por ${Tab3Section4.text}`"
                                                                :cols="$store.getters.STATS_TAB3_SEC4.cols"
                                                                :data="$store.getters.STATS_TAB3_SEC4.data"
                                                                :key="Tab3Section4Id.pie"
                                                            ></pie-chart>

                                                            <bar-chart
                                                                v-if="chartTypeTab3Sec4 === 2"
                                                                :title="`Empleados por ${Tab3Section4.text}`"
                                                                :cols="$store.getters.STATS_TAB3_SEC4.cols"
                                                                :data="$store.getters.STATS_TAB3_SEC4.data"
                                                                :key="Tab3Section4Id.bar"
                                                            ></bar-chart>

                                                            <div class="text-xs-right">
                                                                <v-spacer></v-spacer>
                                                                <v-btn
                                                                    dark
                                                                    icon
                                                                    :color="
                                                                        chartTypeTab3Sec4 === 1 ? 'primary' : 'grey'
                                                                    "
                                                                    @click="chartTypeTab3Sec4 = 1"
                                                                >
                                                                    <v-icon small>fa fa-pie-chart</v-icon>
                                                                </v-btn>
                                                                <v-btn
                                                                    dark
                                                                    icon
                                                                    :color="
                                                                        chartTypeTab3Sec4 === 2 ? 'primary' : 'grey'
                                                                    "
                                                                    @click="chartTypeTab3Sec4 = 2"
                                                                >
                                                                    <v-icon small>fa fa-bar-chart</v-icon>
                                                                </v-btn>
                                                            </div>
                                                        </template>
                                                        <template v-else>
                                                            <div class="text-xs-center">
                                                                <h5>No existen datos que mostrar</h5>
                                                            </div>
                                                        </template>
                                                    </v-card-text>
                                                </v-card>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-tab-item>
                            </v-tabs-items>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

        <!--        <asistencia-estadisticas></asistencia-estadisticas>-->
    </div>
</template>

<script>
import PieChart from "@/components/widgets/pie-chart/PieChart"
import BarChart from "@/components/widgets/bar-chart/BarChart"
import AsistenciaEstadisticas from "./AsistenciaEstadisticas"
import EmpleadoStatsFilter from "@/components/personal/empleado/estadisticas/empleado-stats-filter"

export default {
    components: { EmpleadoStatsFilter, AsistenciaEstadisticas, PieChart, BarChart },
    props: {
        graphOption: { type: String, default: null }
    },
    data() {
        return {
            //tabs
            viewType: "tab-1",

            //para controlar que se aplique el valor obtenido por las props solo 1 vez
            graphOptionApplied: false,

            //saber si se cargaron todos los datos necesarios para seleccionar
            showErrorDataLoadedAlert: false,

            //categorias seleccionadas
            Tab1Section1: {
                show: false,
                text: ""
            },
            Tab2Section1: {
                show: false,
                text: ""
            },
            Tab2Section2: {
                show: false,
                text: ""
            },
            Tab3Section1: {
                show: false,
                text: ""
            },
            Tab3Section2: {
                show: false,
                text: ""
            },
            Tab3Section3: {
                show: false,
                text: ""
            },
            Tab3Section4: {
                show: false,
                text: ""
            },

            //tipos de grafico
            chartTypeTab1Sec1: 1,
            chartTypeTab2Sec1: 1,
            chartTypeTab2Sec2: 1,
            chartTypeTab3Sec1: 1,
            chartTypeTab3Sec2: 1,
            chartTypeTab3Sec3: 1,
            chartTypeTab3Sec4: 1,

            loading: false,

            //id de los graficos
            Tab1Section1Id: {
                pie: 1000,
                bar: 2000
            },
            Tab2Section1Id: {
                pie: 3000,
                bar: 4000
            },
            Tab2Section2Id: {
                pie: 5000,
                bar: 6000
            },
            Tab3Section1Id: {
                pie: 7000,
                bar: 8000
            },
            Tab3Section2Id: {
                pie: 9000,
                bar: 10000
            },
            Tab3Section3Id: {
                pie: 11000,
                bar: 12000
            },
            Tab3Section4Id: {
                pie: 13000,
                bar: 14000
            }
        }
    },

    methods: {
        applyFilter(value) {
            this.loading = true
            if (value.activeFilters > 0) {
                this.$store
                    .dispatch("LOAD_EMPLEADOS_CANTIDAD", {
                        customfilter: value.customFilter,
                        tabSectionQuery: value.tabSectionQuery
                    })
                    .then(result => {
                        if (result) {
                            const filterName = this.getFilterName(value.customFilter)
                            switch (value.tabSectionQuery) {
                                case "Tab1Section1":
                                    this.Tab1Section1.show = true
                                    this.Tab1Section1.text = filterName
                                    this.Tab1Section1Id.pie = this.Tab1Section1Id.pie + 1
                                    this.Tab1Section1Id.bar = this.Tab1Section1Id.bar + 1
                                    break
                                case "Tab2Section1":
                                    this.Tab2Section1.show = true
                                    this.Tab2Section1.text = filterName
                                    this.Tab2Section1Id.pie = this.Tab2Section1Id.pie + 1
                                    this.Tab2Section1Id.bar = this.Tab2Section1Id.bar + 1
                                    break
                                case "Tab2Section2":
                                    this.Tab2Section2.show = true
                                    this.Tab2Section2.text = filterName
                                    this.Tab2Section2Id.pie = this.Tab2Section2Id.pie + 1
                                    this.Tab2Section2Id.bar = this.Tab2Section2Id.bar + 1
                                    break
                                case "Tab3Section1":
                                    this.Tab3Section1.show = true
                                    this.Tab3Section1.text = filterName
                                    this.Tab3Section1Id.pie = this.Tab3Section1Id.pie + 1
                                    this.Tab3Section1Id.bar = this.Tab3Section1Id.bar + 1
                                    break
                                case "Tab3Section2":
                                    this.Tab3Section2.show = true
                                    this.Tab3Section2.text = filterName
                                    this.Tab3Section2Id.pie = this.Tab3Section2Id.pie + 1
                                    this.Tab3Section2Id.bar = this.Tab3Section2Id.bar + 1
                                    break
                                case "Tab3Section3":
                                    this.Tab3Section3.show = true
                                    this.Tab3Section3.text = filterName
                                    this.Tab3Section3Id.pie = this.Tab3Section3Id.pie + 1
                                    this.Tab3Section3Id.bar = this.Tab3Section3Id.bar + 1
                                    break
                                case "Tab3Section4":
                                    this.Tab3Section4.show = true
                                    this.Tab3Section4.text = filterName
                                    this.Tab3Section4Id.pie = this.Tab3Section4Id.pie + 1
                                    this.Tab3Section4Id.bar = this.Tab3Section4Id.bar + 1
                                    break
                            }
                        }
                        this.loading = false
                    })
            }
        },

        getFilterName(customFilter) {
            let filterName = ""
            const filters = {
                campus_id: "Campus",
                departamento_id: "Departamento",
                seccion_id: "Sección",
                puesto_id: "Puesto",
                estado_civil_id: "Estado civil",
                sexo_id: "Sexo",
                escolaridad_id: "Escolaridad",
                titulo_id: "Título",
                recontratacion: "Estado"
            }

            customFilter.split("&").forEach(el => {
                let field = el.split("=")[0]
                filterName += `${filters[field]}, `
            })

            filterName = filterName.slice(0, -2)

            return filterName
        }
    },

    mounted() {
        if (this.graphOption && !this.graphOptionApplied) {
            //si se envio el valor graphOption por las props y no se ha aplicado, se aplica una sola vez
            let value = {}
            switch (this.graphOption) {
                case "1":
                    value = {
                        customFilter: "campus_id=all",
                        activeFilters: 1,
                        tabSectionQuery: "Tab1Section1"
                    }
                    break
                case "2":
                    value = {
                        customFilter: "departamento_id=all",
                        activeFilters: 1,
                        tabSectionQuery: "Tab1Section1"
                    }
                    break
                case "3":
                    value = {
                        customFilter: "sexo_id=all",
                        activeFilters: 1,
                        tabSectionQuery: "Tab1Section1"
                    }
                    break
                case "4":
                    value = {
                        customFilter: "campus_id=all&sexo_id=all",
                        activeFilters: 2,
                        tabSectionQuery: "Tab1Section1"
                    }
                    break
                case "5":
                    value = {
                        customFilter: "departamento_id=all&sexo_id=all",
                        activeFilters: 2,
                        tabSectionQuery: "Tab1Section1"
                    }
                    break
            }

            this.applyFilter(value)
            this.graphOptionApplied = true
        }

        this.$store.dispatch("LOAD_ALL_CAMPUS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_SECCIONES").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_DEPARTAMENTOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_PUESTOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_ESTADOS_CIVIL").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_SEXOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_ESCOLARIDADES").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_TITULOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
    }
}
</script>

<style scoped>
.v-alert {
    padding-top: 3px;
    padding-bottom: 4px;
    margin-top: 1px;
    margin-left: 2px;
    margin-right: 2px;
}
</style>
